import Phaser from 'phaser';
import type { BoogasModel } from '../types';
import { createPlayerView } from './player/player-view';
import { createTigerView } from './tiger/tiger-view';

export function createBoogasComponent(scene: Phaser.Scene, model: BoogasModel) {
  let currentModel = model;
  const getModel = () => currentModel;

  const player = createPlayerView(scene, () => getModel().player);
  const tiger = createTigerView(scene, () => getModel().tiger);

  async function init() {
    await player.init();
    tiger.syncFromScroll(scene.cameras.main.scrollX);
  }

  function setModel(next: BoogasModel) {
    currentModel = next;
    player.setModel();
    tiger.setModel();
  }

  function syncFromScroll(scrollX: number) {
    player.syncFromScroll(scrollX);
    tiger.syncFromScroll(scrollX);
  }

  return {
    init,
    setModel,
    syncFromScroll,
    onTigerTap: tiger.onTap,
    tigerHitTest: tiger.hitTest,
    destroy() {
      player.destroy();
      tiger.destroy();
    },
  };
}

export { queueBoogasLoad } from './tiger/tiger-load';
